import { RouterProvider } from 'react-router-dom';
import { router } from '@/router/routes';
import { BrandingProvider } from '@/contexts/BrandingContext';

export function App() {
  // R3-Sprint5:BrandingProvider 在最顶层包裹 — 解析子域 + 拉品牌 + 注入 antd ConfigProvider 主题
  return (
    <BrandingProvider>
      <RouterProvider router={router} />
    </BrandingProvider>
  );
}
